import { render, staticRenderFns } from "./danmuView.vue?vue&type=template&id=564bd655&"
import script from "./danmuView.vue?vue&type=script&lang=js&"
export * from "./danmuView.vue?vue&type=script&lang=js&"
import style0 from "./danmuView.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports